import { useLiveQuery } from 'dexie-react-hooks'
import { ChevronRight } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'
import { LIBELLES_STATUT, totauxDevis } from '../lib/devis'
import { formatEuro } from '../lib/money'
import { getBase } from '../outbox/base'
import { lister } from '../outbox/depot'

/** Devis du plus récent au plus ancien, avec le nom du client. */
export function useDevisAvecClient() {
  const base = getBase()
  return useLiveQuery(async () => {
    const [tous, clients] = await Promise.all([lister(base, 'devis'), lister(base, 'clients')])
    const noms = new Map(clients.map((c) => [c.id, c.nom]))
    // UUID v7 : l'ordre des id est l'ordre de création
    return tous.sort((a, b) => b.id.localeCompare(a.id)).map((d) => ({ ...d, clientNom: noms.get(d.clientId) ?? '—' }))
  }, [])
}

export type DevisAvecClient = NonNullable<ReturnType<typeof useDevisAvecClient>>[number]

export function LigneDevis({ d }: { d: DevisAvecClient }) {
  const { pathname } = useLocation()
  return (
    <Link
      to={`/devis/${d.id}`}
      aria-current={pathname === `/devis/${d.id}` || pathname.startsWith(`/devis/${d.id}/`) ? 'page' : undefined}
      className="flex min-h-14 items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white shadow-sm p-3 active:bg-slate-50"
    >
      <span className="min-w-0">
        <span className="block truncate font-semibold">{d.clientNom}</span>
        <span className="block text-sm text-slate-700">
          {d.avenantDe && 'Avenant · '}
          {d.numero} · {LIBELLES_STATUT[d.statut]}
        </span>
      </span>
      <span className="flex shrink-0 items-center gap-1 font-semibold">
        {formatEuro(totauxDevis(d).ttc)}
        <ChevronRight aria-hidden className="size-5 text-slate-500" />
      </span>
    </Link>
  )
}
